import RichTextEditor from "../common/ckeditor/RichTextEditor";
import { useProductForm } from "../../contexts/ProductFormContext";

export const DescriptionTab = () => {
  const { product, setProduct } = useProductForm();
  return (
    <div className="p-5 border rounded-xl border-gray-100 bg-white">
      <h2 className="text-lg font-semibold text-black">Mô tả sản phẩm</h2>
      <RichTextEditor
        value={product.product.description}
        onChange={(value) =>
          setProduct((prev) => ({
            ...prev,
            product: {
              ...prev.product,
              description: value,
            },
          }))
        }
        onUpload={(image) =>
          setProduct((prev) => ({
            ...prev,
            product: {
              ...prev.product,
              descriptionImages: [...prev.product.descriptionImages, image],
            },
          }))
        }
      />
    </div>
  );
};
